package app.nestbridge.feature.messages.ui

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import com.karawek.core.ui.theme.CoreTypography
import com.karawek.core.ui.theme.CoreTheme
import com.karawek.core.ui.theme.ThemeMode
import com.karawek.core.ui.theme.ThemeModeProvider
import app.nestbridge.feature.messages.screen.MessagesScreen
import app.nestbridge.feature.messages.screen.MessagesState
import app.nestbridge.ui.theme.NestBridgeTheme
import com.slack.circuit.codegen.annotations.CircuitInject
import androidx.compose.ui.tooling.preview.Preview
import androidx.compose.ui.tooling.preview.PreviewParameter
import software.amazon.lastmile.kotlin.inject.anvil.AppScope

@CircuitInject(
    screen = MessagesScreen::class,
    scope = AppScope::class,
)
@Composable
fun MessagesUi(
    state: MessagesState,
    modifier: Modifier = Modifier,
) {
    Box(
        modifier = modifier.fillMaxSize(),
        contentAlignment = Alignment.Center,
    ) {
        Column(
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.Center,
        ) {
            Text(
                text = "Messages",
                style = CoreTypography.headline,
                color = CoreTheme.colors.textPrimary,
            )
        }
    }
}

// region Previews

@Preview
@Composable
private fun MessagesPreview(
    @PreviewParameter(ThemeModeProvider::class) themeMode: ThemeMode,
) {
    NestBridgeTheme(themeMode = themeMode) {
        MessagesUi(
            state = MessagesState(
                eventSink = {},
            ),
        )
    }
}

// endregion
